module.exports = __webpack_public_path__ + "img/jht-icon-04.12ad0f60.png";